$(document).ready(function () {
  $(".youtube-popup").click(function (e) {
    e.preventDefault();

    const url = $(this).attr("href");
    const match = url.match(/[?&]v=([^&]+)/);
    if (!match) return;

    const videoId = match[1];

    $.colorbox({
      html: `
                <div class="youtubePopupContent">
                    <iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1"
                        frameborder="0"
                        allow="autoplay; encrypted-media"
                        allowfullscreen>
                    </iframe>
                </div>
            `,
      width: "800px",
      maxWidth: "90%",
    });
  });
});
